import {distanceInMinutesFromNow, distanceInWordsFromNow, stringToDate} from "../../../helpers/dateHelper";
import {FormattedMessage} from "react-intl";
import {COMMENT_CREATED_JUST_NOW} from "../constants";

const getFormattedPublicationDate = (createdAt) => {
  const publicationDate = stringToDate(createdAt);

  if (distanceInMinutesFromNow(publicationDate) < 1) {
    return <FormattedMessage id={COMMENT_CREATED_JUST_NOW} />;
  }

  return distanceInWordsFromNow(publicationDate);
};

export {getFormattedPublicationDate}